import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UploadFileToS3 } from "../utils/S3File";
import { useEffect } from "react";
import { getdropdownList, openSignUrl } from "../utils/HelperFunction";
import httpRequest from "../utils/Http";
import { toast } from "react-toastify";

const CourierShippmentForm = ({
  courier_name,
  awb_number,
  shippment_date,
  courier_price,
  courier_file,
  courier_id,
  setIsOpenCourierForm,
  setReload,
}) => {
  const [courierNamelist, setCourierNameList] = useState([]);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    (async () => {
      await getCourierNameList();
    })();
  }, []);

  useEffect(() => {
    if (courier_id) {
      (async () => {
        await getCourierNameList();
      })();

      setFormData({
        courier_name: courier_name,
        awb_number: awb_number,
        courier_price: courier_price,
        courier_date: shippment_date,
        courier_file: courier_file,
        courier_pre_awb: awb_number,
        courier_id: courier_id,
      });
    } else {
      setFormData({});
    }
  }, [
    courier_name,
    awb_number,
    shippment_date,
    courier_price,
    courier_file,
    courier_id,
  ]);

  const getCourierNameList = async () => {
    getdropdownList(setCourierNameList, `getcouriernamelist?is_active=1`);
  };

  useEffect(() => {
    if (
      formData?.awb_number &&
      formData?.courier_pre_awb &&
      formData.awb_number !== formData?.courier_pre_awb
    ) {
      setFormData((prevState) => ({
        ...prevState,
        courier_file: null,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        courier_file: courier_file,
      }));
    }
  }, [formData?.awb_number, formData?.courier_pre_awb]);

  const validateForm = (value) => {
    const errors = {};
    if (!value.courier_name) {
      errors.courier_name = "Courier Name is Required";
    }

    if (!value.awb_number) {
      errors.awb_number = "AWB Number is Required";
    }

    if (!value.courier_price) {
      errors.courier_price = "Courier Price is Required";
    }

    if (!value.courier_date) {
      errors.courier_date = "Courier Date is Required";
    }

    if (!formData.courier_id) {
      errors.courier_id = "Courier ID is Required";
    }

    return errors;
  };

  useEffect(() => {
    if (formData.awb_number && formData.courier_name) {
      (async () => {
        setFormData({ ...formData });
        const courier = await httpRequest(
          `checkcourierexist`,
          {
            awb_number: formData.awb_number,
            courier_name: formData.courier_name,
            isIgnore: true,
          },
          "POST",
        );

        if (courier.status === true && courier.data) {
          setFormData({
            ...formData,
            courier_price: courier.data.courier_price,
            courier_date: courier.data.shippment_date,
            courier_pre_id: courier.data.courier_id,
          });
        } else if (courier.status === false) {
          toast.error(courier.message);
          setFormData({
            ...formData,
            courier_name: null,
            awb_number: "",
          });
        }
      })();
    }
  }, [formData.courier_name, formData.awb_number]);

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        let postData = { ...formData };

        if (formData.tmp_courier_file) {
          const courier_file = await UploadFileToS3(
            "docFile",
            formData.tmp_courier_file,
          );
          postData.courier_file = courier_file;
        }

        const data = await httpRequest(
          "updatecourierdetails",
          postData,
          "POST",
        );

        setSubmit(false);
        if (data.status === true && data.message) {
          toast.success(data.message);
          setIsOpenCourierForm({});
          setFormData({});
          setReload(true);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmit]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(true);
    setFormErrors(validateForm(formData));
    setSubmit(true);
  };

  return (
    <div className="form-overlay">
      <div className="form-container">
        <div className="form-content">
          <form id="courierupdate" onSubmit={onSubmitHandler}>
            <div className="row">
              <div className="col-lg-12">
                <div className="card" style={{ marginBottom: "0px" }}>
                  <div className="card-header">
                    <h3 className="card-title">Update Shippment</h3>
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={() => setIsOpenCourierForm(false)}
                      style={{ float: "right" }}
                    >
                      X
                    </button>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            Courier *{" "}
                            <span style={{ color: "red" }}>
                              {formErrors.courier_name}
                            </span>
                          </label>
                          <Select
                            name="courier_name"
                            value={
                              courierNamelist.find(
                                (option) =>
                                  option.label === formData.courier_name,
                              ) || null
                            }
                            options={courierNamelist}
                            onChange={(val) => {
                              setFormData({
                                ...formData,
                                courier_name: val.label,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            AWB Number *{" "}
                            <span style={{ color: "red" }}>
                              {formErrors.awb_number}
                            </span>
                          </label>
                          <input
                            type="text"
                            name="awb_number"
                            value={formData.awb_number}
                            className="form-control"
                            placeholder="Enter AWB Number"
                            onChange={(val) => {
                              setFormData({
                                ...formData,
                                awb_number: val.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            Courier Price *{" "}
                            <span style={{ color: "red" }}>
                              {formErrors.courier_price}
                            </span>
                          </label>
                          <input
                            type="number"
                            min={0}
                            value={formData.courier_price}
                            name="courier_price"
                            className="form-control"
                            placeholder="Enter Docket NUmber"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                courier_price: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            Courier Date *{" "}
                            <span style={{ color: "red" }}>
                              {formErrors.courier_date}
                            </span>
                          </label>
                          <DatePicker
                            className="form-control text-capitalize"
                            minDate={
                              new Date(
                                new Date().setDate(new Date().getDate() - 7),
                              )
                            }
                            dateFormat="dd/MM/yyyy"
                            selected={
                              formData.courier_date
                                ? new Date(formData.courier_date)
                                : null
                            }
                            placeholderText="Select Courier Date"
                            onChange={(date) => {
                              setFormData({
                                ...formData,
                                courier_date: date,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group">
                          <label>
                            Courier invoice file{" "}
                            <span style={{ color: "red" }}>
                              {formErrors.courier_file}
                            </span>
                            &nbsp;{" "}
                            {formData.courier_file &&
                              formData.awb_number ===
                                formData.courier_pre_awb && (
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() =>
                                    openSignUrl(formData.courier_file)
                                  }
                                >
                                  View File
                                </Link>
                              )}
                          </label>
                          <input
                            type="file"
                            name="courier_file"
                            className="form-control"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                courier_file: e.target.files[0],
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-footer text-center"
                    style={{
                      marginBottom: "60px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <button
                      type="submit"
                      id="submit"
                      className="btn btn-primary col-md-12"
                      style={{ marginLeft: "0px" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CourierShippmentForm;
